/* CREU — Carrusel de imágenes en las mini-fichas (combínalo / completa / más X).
   Scroll horizontal con snap + indicador de línea fina con thumb deslizante. */
(function () {
  function barOf(carousel) {
    var media = carousel.parentElement;
    return media ? media.querySelector('[data-creu-carousel-bar]') : null;
  }

  function syncThumb(carousel) {
    var bar = barOf(carousel);
    if (!bar || !carousel.clientWidth) return;
    var thumb = bar.querySelector('[data-creu-carousel-thumb]');
    if (!thumb) return;
    var n = parseInt(bar.getAttribute('data-slides'), 10) || carousel.children.length || 1;
    var idx = Math.round(carousel.scrollLeft / carousel.clientWidth);
    if (idx < 0) idx = 0;
    if (idx > n - 1) idx = n - 1;
    thumb.style.width = 100 / n + '%';
    thumb.style.transform = 'translateX(' + idx * 100 + '%)';
  }

  // Scroll no burbujea: capturamos en fase de captura.
  document.addEventListener(
    'scroll',
    function (e) {
      var c = e.target;
      if (c && c.nodeType === 1 && c.hasAttribute && c.hasAttribute('data-creu-carousel')) {
        syncThumb(c);
      }
    },
    true
  );

  // Inicializa el ancho del thumb en cada carrusel al cargar.
  function initAll() {
    document.querySelectorAll('[data-creu-carousel]').forEach(syncThumb);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
